
// Creazione di un'istanza di monitoraggio collegata alla funzione di callback
const carrelloScrollableObserver = new MutationObserver(carrelloScrollableCallback);

//Opzioni per il monitoraggio (quali mutazioni monitorare)
const carrelloScrollableConfig = {
    attributes: true,
    childList: true,
    subtree: true
};

// Funzione di callback da eseguire quando avvengono le mutazioni
function carrelloScrollableCallback (mutationsList, carrelloScrollableObserver) {
	const sidebarDx = document.getElementById("sidebar-dx");
	if(sidebarDx){
		for (let mutation of mutationsList) {
			if (sidebarDx.contains(mutation.target)) {
				carrelloScrollableObserver.disconnect();
				enableBetslipScrollbar();
				break;
			}
		}	
		carrelloScrollableObserver.observe(document, carrelloScrollableConfig);
	}
};

export function enableBetslipScrollbar() {
    // Qui si deve mettere in pausa l'observer se esiste, quindi si deve fare un check
    try {
    	carrelloScrollableObserver.disconnect();
        window.removeEventListener("resize", enableBetslipScrollbar, true);
    } catch (err) {
        console.error(err);
    }

    let sidebarDx = document.getElementById("sidebar-dx");
    
    if (sidebarDx != null) {
	    sidebarDx.classList.add("pb-0");
	    sidebarDx.classList.add("h-auto");
    }

    Array.from(document.getElementsByClassName("carrello-scrollable")).forEach(carrelloScrollable => {
        let scrollableTop = carrelloScrollable.getBoundingClientRect().y;

        if (carrelloScrollable.getBoundingClientRect().width !== 0 && carrelloScrollable.getBoundingClientRect().height !== 0) {
            let parent = carrelloScrollable.parentElement;
            let carrelloFixed = parent.getElementsByClassName("carrello-fixed")[0];

            let carrelloFixedHeight = carrelloFixed.getBoundingClientRect().height;

            let windowHeight = window.innerHeight;

            let carrelloScrollableMaxHeight = windowHeight - scrollableTop - carrelloFixedHeight - 20;

            carrelloScrollable.style.maxHeight = carrelloScrollableMaxHeight + "px";
            carrelloScrollable.classList.add("overflow-y-scroll");

            carrelloScrollableCheckShadowedClass(carrelloScrollable);
        }
    });

    //Qui si ri/attivano l'observer e il listener
    carrelloScrollableObserver.observe(document, carrelloScrollableConfig);
    window.addEventListener("resize", enableBetslipScrollbar, true);
    
    document.querySelectorAll(".carrello-scrollable").forEach(element => {
        element.addEventListener('scroll', betslipScrollEventListener, true);
    });
}

function betslipScrollEventListener(event) {
	let carrelloScrollable = event.target;
    carrelloScrollableCheckShadowedClass(carrelloScrollable);
}

function carrelloScrollableCheckShadowedClass(carrelloScrollable) {
    let carrelloScrollable_ScrollHeight = carrelloScrollable.scrollHeight
    //let carrelloScrollable_Height = carrelloScrollable.getBoundingClientRect().height
    let carrelloScrollable_Height = carrelloScrollable.offsetHeight
    let carrelloScrollable_ScrollTop = carrelloScrollable.scrollTop

    if (carrelloScrollable_ScrollHeight - carrelloScrollable_Height == carrelloScrollable_ScrollTop) {
        carrelloScrollable.classList.remove("carrello-scrollable-shadowed")
    } else {
        carrelloScrollable.classList.add("carrello-scrollable-shadowed")
    }
}

export function disableBetslipScrollbar() {
    //Rimuoviamo observer e listener
    try {
        carrelloScrollableObserver.disconnect();
        window.removeEventListener("resize", enableBetslipScrollbar, true);
    } catch (err) {
        console.error(err);
    }

    //Rimuoviamo le classi che erano state assegnate
    let sidebarDx = document.getElementById("sidebar-dx");

    if (sidebarDx != null) {
    	sidebarDx.classList.remove("pb-0");
    	sidebarDx.classList.remove("h-auto");    	
    }

    Array.from(document.getElementsByClassName("carrello-scrollable")).forEach(carrelloScrollable => {
        carrelloScrollable.style.maxHeight = "unset";
        carrelloScrollable.classList.remove("overflow-y-scroll");
        carrelloScrollable.classList.remove("carrello-scrollable-shadowed");
    });
    
    document.querySelectorAll(".carrello-scrollable").forEach(element => {
        element.removeEventListener('scroll', betslipScrollEventListener, true);
    });
}

export function disableBetslipScrollObserver() {
    carrelloScrollableObserver.disconnect();
}

export function setFastbetCartEventListeners(goToAmountFieldChar) {
    document.removeEventListener('keydown', f2handler, true);
    document.addEventListener('keydown', f2handler, true);
    
    if (goToAmountFieldChar) {
        window.goToAmountFieldChar = goToAmountFieldChar;
        document.removeEventListener('keydown', handlerGoToAmountField, true);
        document.addEventListener('keydown', handlerGoToAmountField, true);  		 
    } else {
        document.removeEventListener('keydown', handlerGoToAmountField, true);
        window.goToAmountFieldChar = null;
    }
}

function f2handler(event) {
    if (event.which == 113) { //F2
        document.getElementById('fastbet-cart-event').focus();
        return false;
    }
}

function handlerGoToAmountField(event) {
	if ((event.which == 187 || event.which == 107) && window.goToAmountFieldChar === "PLUS") {
		window.switchFocusOnTheFirstAmountField();
	} else if ((event.which == 106) && window.goToAmountFieldChar === "STAR") {
		window.switchFocusOnTheFirstAmountField();
	}
	return false;
}
